
import { message } from 'antd';
import {
  fetchAudience,
  createAudience,
  updateAudience,
  deleteAudience,
  fetchConversion,
  createConversion,
  editConversion,
  checkIfCanOpenDebugSwitch,
  updateDebugStatus,
  refreshClickEventReq,
  refreshClickEventRes,
  bindAccount,
  queryAccountHistory,
  getAccountBindInfo,
  getLogContant,
  getLogList,
  getNOSToken,
  fetchProductInfo,
  updateAdFormAPK,
  queryAdFormByApk,
  updateAPkName,
  updatePackageName,
  updateAPkVersion,
  updateApkInfo,
  createAPK,
  deleteAPK,
  resubmitApk,
  fetchEffects,
  fetchEffectsEvoke,
  updateStatus,
  fetchWebConversionConstant,
  fetchWechatConversionConstant,
  fetchApiWebConversionConstant,
  fetchWebConversionDebugResult,
  deleteConversion,
  getConversionDebugResult,
  getQueryName,
  getIndustryGroupPage,
  fetchIndustry,
} from '../services/api';

export default {
  namespace: 'tools',

  state: {
    data: {
      list: [],
      pagination: {},
      adPlanId: null,
    },
    effectsData: [],
    audienceList: [],
    loading: true,
    accountBindInfo: null,
    accountHistory: [],
    logList: [],
    logContant: {},
    totalCount: '',
    currentPager: '',
    needCloseConversionId: '',
    conversionTrackResDataInfo:{
      isMark: null,
    },
    apkPackageList: [],
    threadList: [],
    conversionConstant: [],
    queryNameOps: [],
  },

  effects: {
    *fetchIndustryGroupPage({ payload, callback }, { call }) {
      const response = yield call(getIndustryGroupPage, payload);
      if (callback && response) {
        callback(response);
      }
    },

    *fetchIndustryList({ payload, callback }, { call, put }) {
      const industryList = yield call(fetchIndustry);
      const sponsorIndustryList = (industryList || []).map(item => ({
        key: item.uid,
        label: item.name,
        parent: item.parentUid,
      }));
      if (callback) {
        callback(sponsorIndustryList);
      }
    },

    *fetchAudience({ payload }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(fetchAudience, payload);
      yield put({
        type: 'loadAudience',
        payload: response,
      });
      yield put({
        type: 'changeLoading',
        payload: false,
      });
    },

    *fetchWebConversionDebugResult({ payload }, { call }) {
      const response = yield call(fetchWebConversionDebugResult, payload);
      return (response || {}).data
    },

    *createAudience({ payload, callback}, { call, put }) {
      const response = yield call(createAudience, payload);
      if (response) {
        message.success('创建成功');
        callback();
      }
    },

    *updateAudience({ payload , callback}, { call, put }) {
      const response = yield call(updateAudience, payload);
      if (response) {
        message.success('编辑成功');
        callback();
      }
    },

    *deleteAudience({ payload , callback}, { call, put }) {
      const response = yield call(deleteAudience, payload);
      if (response) {
        message.success('删除成功');
        if(callback) {
          callback()
        };
      }
    },

    *getConversionDebugResult({ payload }, { call }) {
      const response = yield call(getConversionDebugResult, payload)
      return (response || {}).data
    },

    *getQueryName({ payload }, { call, put }) {
      const response = yield call(getQueryName, payload)
      if (response) yield put({ type: 'putQueryName', payload: response });
    },

    *fetchEffects({ payload } , { call, put }) {
      const response = yield call(fetchEffects)
      yield put({
        type: 'getEffectsData',
        payload: response,
      })
    },

    *fetchEffectsEvoke({ payload } , { call, put }) {
      const response = yield call(fetchEffectsEvoke)
      yield put({
        type: 'getEffectsData',
        payload: response,
      })
    },

    *fetchConversion({ payload }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(fetchConversion, payload);
      yield put({
        type: 'loadConversion',
        payload: response,
      });
      yield put({
        type: 'changeLoading',
        payload: false,
      });
    },

    *createConversion({ payload }, { call, put }) {
      const response = yield call(createConversion, payload);
      yield put({
        type: 'createdConversion',
        payload: response,
      });
      return response;
    },

    *deleteConversion({ payload }, { call }) {
      const response = yield call(deleteConversion, payload);
      if (response) {
        message.success('删除成功');
      }
    },

    *editConversion({ payload }, { call, put }) {
      const response = yield call(editConversion, payload);
      yield put({
        type: 'editedConversion',
        payload: response,
      });
      return response;
    },

    *checkIfCanOpenDebugSwitch({ payload }, { call, put }) {
      const response = yield call(checkIfCanOpenDebugSwitch, payload);
      yield put({
        type: 'checkedIfCanOpenDebugSwitch',
        payload: response,
      });
    },

    *updateDebugStatus({ payload }, { call, put }) {
      const response = yield call(updateDebugStatus, payload);
      yield put({
        type: 'updatedDebugStatus',
        payload: response,
      });
    },

    *refreshClickEventReq({ payload }, { call, put }) {
      const response = yield call(refreshClickEventReq, payload);
      yield put({
        type: 'refreshedClickEventReq',
        payload: response,
      });
    },

    *refreshClickEventRes({ payload }, { call, put }) {
      const response = yield call(refreshClickEventRes, payload);
      yield put({
        type: 'refreshedClickEventRes',
        payload: response,
      });
    },

    *bindAccount({ payload }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(bindAccount, payload);
      if(response) {
        yield put({
          type: 'loadAccountBindInfo',
          payload: response,
        });
      }
      yield put({
        type: 'changeLoading',
        payload: false,
      });
    },

    *updateStatus({ payload }, { call, put }) {
      const response = yield call(updateStatus, payload);
      yield put({
        type: 'checkUpdate',
        payload: response,
      });
    },

    *queryAccountHistory({ payload }, { call, put }) {
      const response = yield call(queryAccountHistory, payload);
      yield put({
        type: 'loadAccountHistory',
        payload: response,
      });
    },

    *getAccountBindInfo({ payload, callback }, { call, put }) {
      const response = yield call(getAccountBindInfo, payload);
      yield put({
        type: 'loadAccountBindInfo',
        payload: response,
      });
      if (callback) {
        callback(response);
      }
    },

    *getLogContant({ payload, callback }, { put, call }) {
      const response = yield call(getLogContant);
      if (response) {
        yield put({
          type: 'logContant',
          payload: response,
        })
      }
    },

    *getLogList({ payload, callback }, { put, call }) {
      const response = yield call(getLogList, payload);
      if (response) {
        yield put({
          type: 'logList',
          payload: response,
        })
      }
    },

    *getNOSToken({ payload, callback, failed }, { put, call }) {
      const response = yield call(getNOSToken, payload);
      if (response) {
        callback(response.data)
      } else {
        failed()
      }
    },

    *apkList({ payload, callback }, { put, call }) {
      const response = yield call(fetchProductInfo, payload);
      if (response) {
        callback(response);
      }
    },

    *fetchApkList({ payload }, { put, call }) {
      const response = yield call(fetchProductInfo, payload);
      if (response) {
        yield put({
          type: 'apkResult',
          payload: response,
        })
      }
    },

    *replaceApk({ payload, callback }, { put, call }) {
      const response = yield call(updateAdFormAPK, payload);
      callback(response);
    },
    *fetchAdsByApk({ payload, callback }, { put, call }) {
      const response = yield call(queryAdFormByApk, payload);
      if (response) callback(response);
      else callback(null);
    },
    *updateApkName({ payload, callback }, { put, call }) {
      const response = yield call(updateAPkName, payload);
      callback(response);
    },
    *updatePackageName({ payload, callback }, { put, call }) {
      const response = yield call(updatePackageName, payload);
      callback(response);
    },
    *updateApkVersion({ payload, callback }, { put, call }) {
      const response = yield call(updateAPkVersion, payload);
      callback(response);
    },
    *updateApkInfo({ payload, callback }, { put, call }) {
      const response = yield call(updateApkInfo, payload);
      callback(response);
    },
    *createAPK({ payload, callback }, { put, call }) {
      const response = yield call(createAPK, payload);
      callback(response);
    },
    *deleteApk({ payload, callback }, { put, call }) {
      const response = yield call(deleteAPK, payload);
      callback(response);
    },
    *resubmitApk({ payload, callback }, { put, call }) {
      const response = yield call(resubmitApk, payload);
      callback(response);
    },

    // 线索转化
    *fetchWebConversionConstant({ payload }, { put, call }) {
      // 线索转化和api转化的转化目标走两个接口
      let response;
      if(payload === 1) {
        response = yield call(fetchWebConversionConstant, payload);
      } else if (payload === 21) {
        response = yield call(fetchApiWebConversionConstant, payload);
      } else {
        response = yield call(fetchWechatConversionConstant, payload)
      }
      if (response) {
        yield put({
          type: 'conversionConstant',
          payload: response,
        })
      }
    },

  },

  reducers: {
    putQueryName(state, { payload }) {
      const queryNameOps =
        (Array.isArray(payload.data)
          ? payload.data : []).map(({ name }) => ( name ));
      return {
        ...state,
        queryNameOps,
      }
    },
    conversionConstant(state, { payload }) {
      return {
        ...state,
        conversionConstant: payload.data || [],
      }
    },

    apkResult(state, { payload }) {
      return {
        ...state,
        apkPackageList: payload.list || [],
      }
    },

    logList(state, { payload }) {
      return {
        ...state,
        logList: payload.list,
        totalCount: payload.totalCount,
        currentPager: payload.currentPager,
      };
    },
    checkUpdate(state, {payload}) {
      return {
        ...state,
        updateMessage: payload,
      }
    },
    logContant(state, { payload }) {
      return {
        ...state,
        logContant: payload,
      };
    },
    loadAudience(state, { payload }) {
      const audienceList = payload.list;
      return {
        ...state,
        audienceList: Array.isArray(audienceList) ? audienceList : [],
      };
    },
    createAudience(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },

    loadConversion(state, { payload }) {
      const conversionList = payload.data.records;
      const {page} = payload.data;
      return {
        ...state,
        conversionPage: {
          current: page.current,
          pageSize: page.size,
          total: page.recordCount,
        },
        conversionList: Array.isArray(conversionList) ? conversionList : [],
      };
    },
    createdConversion(state, { payload }) {
      const {code} = payload;
      const createConversionSuccess = code === 200;
      if (createConversionSuccess) {
        message.success('创建成功');
      }
      return {
        ...state,
        createConversionSuccess,
        createConversionMessage: payload.message,
      };
    },

    getEffectsData(state, { payload }) {
      console.log(payload)
      return {
        ...state,
        effectsData: payload.data,
      }
    },

    editedConversion(state, { payload }) {
      const editConversionSuccess = payload.code === 200;
      if (editConversionSuccess) {
        message.success('修改成功');
      }
      return {
        ...state,
        editConversionSuccess,
        editConversionMessage: payload.message,
      };
    },
    checkedIfCanOpenDebugSwitch(state, { payload }) {
      const canOpenDebugSwitch = payload.code === 200;
      return {
        ...state,
        canOpenDebugSwitch,
        canOpenDebugSwitchMessage: payload.message,
        needCloseConversionId: payload.data ? payload.data.conversionId : '',
      };
    },
    updatedDebugStatus(state, { payload }) {
      const updatedDebugStatusSuccess = payload.code === 200;
      if (updatedDebugStatusSuccess) {
        message.success('更新成功');
      }
      return {
        ...state,
      };
    },
    refreshedClickEventReq(state, { payload }) {
      const refreshedClickEventReqSuccess = payload.code === 200;
      const conversionTrackReqDataInfo = payload.data;
      return {
        ...state,
        conversionTrackReqDataInfo,
      };
    },
    refreshedClickEventRes(state, { payload }) {
      const refreshedClickEventResSuccess = payload.code === 200;
      const conversionTrackResDataInfo = payload.data;
      return {
        ...state,
        conversionTrackResDataInfo,
      };
    },
    clear() {
      return {
        data: {
          list: [],
          pagination: {},
          adPlanId: null,
        },
        audienceList: [],
        loading: true,
      };
    },
    loadAccountHistory(state, { payload }) {
      return {
        ...state,
        accountHistory: Array.isArray(payload) ? payload : [],
      };
    },
    loadAccountBindInfo(state, { payload }) {
      return {
        ...state,
        accountBindInfo: payload,
      };
    },
  },
};
